import React from 'react';
import '../styles/OurBrands.css';

const OurBrands = () => {
  return (
    <div className="our-brands-container">
      <h2>OUR BRAND TESTIMONIALS</h2>
      
      <div className="brands-wrapper">
        {/* Chemoleum Video Card */}
        <div className="brand-card">
          <h3>Chemoleum</h3>
          <video controls className="brand-video">
            <source src={require('../videos/Chemoleum.mp4')} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Balmerol Video Card */}
        <div className="brand-card">
          <h3>Balmerol</h3>
          <video controls className="brand-video">
            <source src={require('../videos/Balmerol.mp4')} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
};

export default OurBrands;
